import * as React from "react"
import { SettingsBlockContent } from "@modules/site/settings"
import Loading from "@modules/ui/components/Loading"
import { ManualWebhookIntegrations } from "./ManualWebhookIntegrations"
import { CmsManualIntegrationRow } from "./CmsManualIntegrationRow"
import { CmsProvider } from "@modules/graphql/types"

type ManualIntegrationContentProps = {
  loading: boolean
  error: { message: string }
  cmsIntegrations: CmsProvider[]
  siteId: string
}

function ManualIntegrationContent({
  loading,
  error,
  cmsIntegrations,
  siteId,
}: ManualIntegrationContentProps) {
  if (loading) {
    return (
      <Loading
        data-testid="manual-integration-loading"
        delay={1000}
        message="loading available cms integrations..."
        bufferSize="none"
      />
    )
  }

  if (error) {
    return <p data-testid="manual-integration-error">{error.message}</p>
  }

  if (cmsIntegrations.length === 0) {
    return (
      <p data-testid="manual-integration-no-integrations">No integrations</p>
    )
  }

  return (
    <div data-testid="manual-integrations">
      {cmsIntegrations.map(cms => {
        return <CmsManualIntegrationRow key={cms.name} {...cms} />
      })}

      <ManualWebhookIntegrations siteId={siteId} />
    </div>
  )
}

type CmsManualIntegrationProps = {
  loading: boolean
  error: { message: string }
  cmsIntegrations: CmsProvider[]
  siteId: string
  orgSiteName: string
  permissionToEdit: boolean
}

export function CmsManualIntegration({
  loading,
  error,
  cmsIntegrations = [],
  siteId,
}: CmsManualIntegrationProps) {
  return (
    <SettingsBlockContent>
      <ManualIntegrationContent
        loading={loading}
        error={error}
        cmsIntegrations={cmsIntegrations}
        siteId={siteId}
      />
    </SettingsBlockContent>
  )
}
